import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import React, { createContext, useState } from "react";
import Header from "./Header";
import MonitoringHistoryTable from "./MonitoringNotificationsTable";
import MonitoringStatsHeader from "./MonitoringStatsHeader";
import MonitorsTable from "./MonitorsTable";

export const PendingNotificationsCountContext = createContext<number | null>(
  null
);

export default function Monitoring() {
  const [tabIndex, setTabIndex] = useState("1");
  const [pendingNotificationCount, setPendingNotificationCount] = useState<
    number | null
  >(null);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabIndex(newValue);
  };

  return (
    <PendingNotificationsCountContext.Provider value={pendingNotificationCount}>
      <Box>
        <Header />
        <MonitoringStatsHeader />
        <Box sx={{ mt: 5 }}>
          <TabContext value={tabIndex}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Notifications" value="1" />
                <Tab label="Monitors" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <MonitoringHistoryTable
                setPendingNotificationCount={setPendingNotificationCount}
              />
            </TabPanel>
            <TabPanel value="2">
              <MonitorsTable />
            </TabPanel>
          </TabContext>
        </Box>
      </Box>
    </PendingNotificationsCountContext.Provider>
  );
}
